export function isAuthenticated(authObj) {
    if (typeof authObj !== "object") return false;
    let keyName = Object.keys(authObj)[0];

    return keyName === "authToken";
}